import { css } from '@bd/bdui-styles/emotion';

const gridColumns = 12;
const gridGutterWidth = 30;

const gridMixins = {
  makeContainer: () => css`
    width: 100%;
    padding-right: ${gridGutterWidth / 2}px;
    padding-left: ${gridGutterWidth / 2}px;
    margin-right: auto;
    margin-left: auto;
  `,
  makeRow: () => css`
    display: flex;
    flex-wrap: wrap;
    margin-right: ${gridGutterWidth / -2}px;
    margin-left: ${gridGutterWidth / -2}px;
  `,
  makeCol: (size, columns = gridColumns) => css`
    position: relative;
    // Prevent columns from becoming too narrow when at smaller grid tiers by
    // always setting 'width: 100%;'. This works because we use 'flex' values
    // later on to override this initial width.
    width: 100%;
    min-height: 1px; // Prevent collapsing
    padding-right: ${gridGutterWidth / 2}px;
    padding-left: ${gridGutterWidth / 2}px;

    flex: 0 0 ${((size / columns) * 100).toFixed(6)}%;
    // Add a 'max-width' to ensure content within each column does not blow out
    // the width of the column. Applies to IE10+ and Firefox. Chrome and Safari
    // do not appear to require this.
    max-width: ${((size / columns) * 100).toFixed(6)}%;
  `,
};

export default gridMixins;



// WEBPACK FOOTER //
// ./src/styles/grid.js